import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BarChart, pieArcLabelClasses, PieChart } from '@mui/x-charts';
import { getTotalTxnsByDayService, getTotalTxnsByOperatorsService } from 'services/panelService';
import moment from 'moment';
import { Grid } from '@mui/material';
import PanelTransactionsScreen from './PanelTransactionsScreen';
import PanelPaymentsScreen from './PanelPaymentsScreen';
import PanelBinnacleScreen from './PanelBinnacleScreen';
import { Loader } from 'rsuite';
import PanelAlertsScreen from './PanelAlertsScreen';
import PanelConciliacionScreen from './PanelConciliacionScreen';
import PanelIntermitenciasScreen from './PanelIntermitenciasScreen';
import { useDispatch, useSelector } from 'react-redux';
import { getLastOpenIntermittences } from 'services/admin/alertsService';
import { CustomButton } from 'components';
import { setCurrentIntermittence } from 'redux/slices/admin/alertSlice';
import { setTitle } from 'redux/slices/uiSlice';
import theme from 'config/theme';
import { getPendingTasksService } from 'services/admin/taskService';

const PanelScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { type } = useSelector(store => store.session);
  const [graph, setGraph] = useState({})
  const [operators, setOperators] = useState({})
  const [loading, setLoading] = useState(false)
  const [intermittence, setIntermittence] = useState(null)
  const [task, setTask] = useState(0)
  useEffect(() => {
    dispatch(setTitle('Panel de control'));
    setLoading(true)
    if (type === 'admin') {
      getLastOpenIntermittences().then((response) => {
        setIntermittence(response)
      })
      getPendingTasksService().then((response) => {
        setTask(response)
      })
    }
    getTotalTxnsByDayService().then((response) => {
      setGraph(response.reduce((acc, { _id, total }) => {
        const date = moment(_id).format('MM/DD');
        acc[date] = (acc[date] || 0) + total;
        return acc;
      }, {}))
    }).finally(() => setLoading(false))
    getTotalTxnsByOperatorsService().then((response) => {
      setOperators(response.reduce((acc, { _id, total }) => {
        acc[_id.operator] = (acc[_id.operator] || 0) + total;
        return acc;
      }, {}))
    }).finally(() => setLoading(false))
  }, []);
  return (
    <>
      {
        intermittence &&
        <CustomButton
          name={'Intermitencia'}
          sx={{
            backgroundColor: '#EA0153',
            borderColor: '#EA0153',
          }}
          click={() => {
            dispatch(setCurrentIntermittence(intermittence));
            navigate('../admin/alertas/intermitencias/transacciones')
          }}
        />
      }
      {
        task !== 0 &&
        <CustomButton
          name={`Tareas pendientes (${task})`}
          sx={{
            backgroundColor: '#EA0153',
            borderColor: '#EA0153',
          }}
          click={() => {
            navigate('../admin/tareas')
          }}
        />
      }
      <h2 className='title' style={{ textAlign: 'center' }}>Ventas de los últimos 30 diás</h2>
      {
        loading ? <div style={{ textAlign: 'center', height: 300 }}> <Loader size='lg' style={{ marginTop: 100 }} /> </div> : (
          <Grid container spacing={2} mt={2}>
            <Grid item xs={9} >
              <span style={{ fontSize: '20px', fontWeight: 'bold', marginLeft: '46px' }}>Ventas de los últimos 30 diás</span>
              <BarChart
                loading={loading}
                yAxis={[]}
                xAxis={[{
                  scaleType: 'band',
                  data: Object.keys(graph),
                  tickPlacement: 'middle'

                }]}
                series={[
                  {
                    type: 'bar',
                    data: Object.values(graph)
                  }
                ]}
                colors={[theme.contrastColor]}
                grid={{ horizontal: true }}
                // borderRadius={10}
                // barLabel="value"
                // width={500}
                height={300}
              />
            </Grid>
            <Grid item xs={3}>
              <PieChart
                colors={theme.graph}
                series={[
                  {
                    data: Object.entries(operators).map(([operator, total]) => ({ id: operator, value: total, label: operator, })),
                    arcLabel: (params) => params.label ?? '',
                    arcLabelMinAngle: 35,
                    arcLabelRadius: '60%',
                  },
                ]}
                sx={{
                  [`& .${pieArcLabelClasses.root}`]: {
                    fontWeight: 'bold',
                    color: '#FFFFFF'
                  },
                }}
                // width={400}
                height={300}
                slotProps={{
                  legend: { hidden: true },
                }}
              />
            </Grid>
          </Grid>

        )
      }
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} sm={4}>
          <PanelTransactionsScreen slim={true} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <PanelPaymentsScreen slim={true} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <PanelBinnacleScreen slim={true} />
        </Grid>
        {
          type == 'admin' && <>
            <Grid item xs={12} sm={4}>
              <PanelIntermitenciasScreen slim={true} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <PanelConciliacionScreen slim={true} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <PanelAlertsScreen slim={true} />
            </Grid>
          </>
        }
      </Grid>
    </>
  )
}

export default PanelScreen;